export const en = {
  nameLabel: 'Project name',
  namePlaceholder: 'My Amazing Project',
  permission:
    'Allow clients on this project to see feedback from other clients',
  allow_guests_change_task_status:
    'Allow Clients to change the status of a task',
  guestsHelpArticleId: '85000',
  createError: 'Something went wrong, please try again.',
  createSuccess: 'The project has been created successfully.',
  emptyValidationMessage: 'Please complete this field',
  createProject: `Create Project`,
  createNewProject: 'Create new project',
  assign_guests: 'Allow Clients to be assigned to tasks',
  allow_project_summary_email:
    'Allow Clients to receive project summary emails',
  allow_task_done_email: 'Allow Clients to receive task done emails',
  change_guest_default_column: 'Send new client feedback to'
};

export type Translations = typeof en;
